import React, { useEffect } from "react";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input } from "antd";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";
import TextArea from "antd/es/input/TextArea";

interface OverviewProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  overviewData?: { heading?: string; subtext?: string };
  loading?: boolean;
}

const LookingChangeOverview: React.FC<OverviewProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  overviewData,
  loading,
}) => {
  useEffect(() => {
    if (overviewData) {
      form.setFieldsValue({
        heading: overviewData.heading || "",
        subtext: overviewData.subtext || "",
      });
    } else {
      form.resetFields();
    }
  }, [overviewData, form]);

  console.log("overviewData", overviewData);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left text-sm md:text-base">
                    Heading
                  </th>
                  <th className="py-3 px-4 text-center text-sm md:text-base">
                    Subtext
                  </th>
                  <th className="py-3 px-4 text-end text-sm md:text-base ">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {overviewData ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 w-[120px]">
                      {overviewData?.heading || "—"}
                    </td>
                    <td className="py-3 px-4 text-center ">
                      {overviewData?.subtext || "—"}
                    </td>
                    <td className="py-3 px-4 h-full text-primary">
                      <div className="flex items-center justify-end gap-4 h-full">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-primary text-[20px]"
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden">
            {overviewData ? (
              <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <div>
                  <div>
                    <b className="text-primary">Heading:</b>
                  </div>
                  <p>{overviewData?.heading || "—"}</p>
                </div>

                <div>
                  <div>
                    <b className="text-primary">Subtext:</b>
                  </div>
                  <p>{overviewData?.subtext || "—"}</p>
                </div>

                <div className="">
                  <EditOutlined
                    onClick={() => setIsEditing(true)}
                    className="cursor-pointer text-primary text-[20px]"
                  />
                </div>
              </div>
            ) : (
              <div className="bg-[#F9F9F9] border flex justify-center border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  {" "}
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name="heading"
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading" />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name="subtext"
                rules={[
                  { required: true, message: "Please upload a banner image" },
                ]}
              >
                <TextArea rows={3} placeholder="enter subtext..." />
              </Form.Item>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default LookingChangeOverview;
